module.exports = __webpack_public_path__ + "assets/img/video-btn-a8412ae5.png";